import { render, staticRenderFns } from "./CenterViewEventList_Ap.vue?vue&type=template&id=f3a264ac&scoped=true"
import script from "./CenterViewEventList_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventList_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventList_Ap.vue?vue&type=style&index=0&id=f3a264ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a264ac",
  null
  
)

export default component.exports